module.exports = __webpack_public_path__ + "img/184-Gris Sécurité Veiné.jpg";